"use strict";

module.exports = function () {/* empty */};


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/_add-to-unscopables.js
// module id = 147
// module chunks = 2